import { Component, OnChanges, ChangeDetectionStrategy, input } from '@angular/core';
import {UnitConversionUtils} from '../../configurator/unit-conversion-utils';
import {SureFlowRatingCoilResponse} from '../../model/sure-flow-rating-coil-response';
import { DecimalPipe } from '@angular/common';

@Component({
    selector: 'app-sure-flow-performance-coil-output',
    templateUrl: './sure-flow-performance-coil-output.component.html',
    styleUrls: ['./sure-flow-performance-coil-output.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [DecimalPipe]
})
export class SureFlowPerformanceCoilOutputComponent implements OnChanges {

  readonly fieldLabel = input.required<string>();
  readonly response = input.required<SureFlowRatingCoilResponse>();
  readonly isMetric = input.required<boolean>();
  readonly isHeat = input.required<boolean>();

  constructor() {
  }

  ngOnChanges() {
  }

  getCapacityUnits(): string {
    return UnitConversionUtils.getCapacityUnits(this.isMetric());
  }

  getTemperatureUnits(): string {
    return UnitConversionUtils.getTemperatureUnits(this.isMetric());
  }

  getFlowRateUnits(): string {
    return UnitConversionUtils.getFlowRateUnits(this.isMetric());
  }

}
